import { render, staticRenderFns } from "./cabinet-deals.vue?vue&type=template&id=3734577f&scoped=true"
import script from "./cabinet-deals.vue?vue&type=script&lang=js"
export * from "./cabinet-deals.vue?vue&type=script&lang=js"
import style0 from "./cabinet-deals.vue?vue&type=style&index=0&id=3734577f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734577f",
  null
  
)

export default component.exports